// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCcPumyBvANpUwG1qwE3ZTkIQh4wZPMM8k",
  authDomain: "zeckswitch-62917.firebaseapp.com",
  projectId: "zeckswitch-62917",
  storageBucket: "zeckswitch-62917.firebasestorage.app",
  messagingSenderId: "1059993038028",
  appId: "1:1059993038028:web:03adeafc886a8a31672669",
  measurementId: "G-B4G4Q4YJ1B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only if in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export default app;
export { analytics };